<mat-sidenav-container class="flyout-sidenav">
    <mat-sidenav #flyOut position="end" [disableClose]="true" [fixedInViewport]="true" mode="over">

        <div class="flyout-container flex-col">
            <nova-detail-toolbar [showBackButton]="false" [template]="headerButtons"
                title="Select Template: {{selectedDoc?.documentTypeName}}" class="flyout-toolbar"></nova-detail-toolbar>
            <div class="flyout-container__search box">
                <nova-search-template (searchTemplates)="searchTemplates($event)"></nova-search-template>
            </div>
            <div class="full-height flex-row">

                <div class="flyout-container__folder box flex-40">
                    <nova-template-folder-list></nova-template-folder-list>
                </div>
                <div class="flyout-container__template box flex-60">
                    <nova-template-grid (selectedTemplate)="templateSelected($event)"></nova-template-grid>
                </div>
            </div>
        </div>
    </mat-sidenav>
</mat-sidenav-container>

<ng-template #headerButtons>
    <div class="header">
        <span *ngIf="(canRemoveMapping$ | async) || selectedDoc?.isAdHoc || isRequirementsPage">
            <button mat-raised-button color="primary" (click)="associateTemplate()" [disabled]="!selectedTemplate">
                ASSIGN SELECTED
            </button>
        </span>
        <button color="default" mat-raised-button (click)="cancel()">CANCEL</button>
    </div>
</ng-template>
